import React, { useEffect, useState } from "react";
import axios from "axios";

export default function NoticePage() {
    const [notices, setNotices] = useState([]);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchNotices() {
            try {
                const res = await axios.get("/api/notices");
                setNotices(res.data);
            } catch (err) {
                console.error("공지사항 목록을 불러오지 못했습니다.", err);
            } finally {
                setLoading(false);
            }
        }
        fetchNotices();
    }, []);

    const handleAdd = async () => {
        if (!title.trim() || !content.trim()) return;
        try {
            await axios.post("/api/manage/notices", { title: title, content: content });
            setTitle("");
            setContent("");

            alert("공지사항 등록 성공");
            window.location.reload();
        } catch (err) {
            alert("공지사항 등록 실패: " + err.message);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("정말로 삭제하시겠습니까?")) return;
        try {
            await axios.delete(`/api/manage/notices/${id}`);
            setNotices(notices.filter(n => n.id !== id));
            alert("삭제 성공");
        } catch (err) {
            alert("삭제 실패: " + err.message);
        }
    };

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }

    return (
        <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>공지사항</h2>
            <div style={{
                border: "1px solid #e1e1e1", borderRadius: 8, padding: 20, marginBottom: 32, background: "#fafbfc"
            }}>
                <div style={{ marginBottom: 12 }}>
                    <input
                        type="text"
                        placeholder="제목"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 8, borderRadius: 4, border: "1px solid #ccc" }}
                    />
                    <textarea
                        placeholder="내용"
                        value={content}
                        onChange={e => setContent(e.target.value)}
                        rows={4}
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                    />
                </div>
                <button
                    onClick={handleAdd}
                    style={{
                        background: "#1677ff", color: "#fff", border: "none", borderRadius: 4,
                        padding: "8px 24px", fontWeight: 600, cursor: "pointer"
                    }}
                >
                    등록
                </button>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <thead>
                    <tr style={{ background: "#f5f6fa", width: '100%' }}>
                        <th style={{ padding: "10px 8px", borderBottom: "2px solid #e1e1e1" }}>제목/내용</th>
                        <th style={{ padding: "10px 8px", borderBottom: "2px solid #e1e1e1" }}>작성일</th>
                        <th style={{ padding: "10px 8px", borderBottom: "2px solid #e1e1e1" }}>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {notices.map(notice => (
                        <tr key={notice.id} style={{ background: "#fff" }}>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", wordBreak: "break-all", whiteSpace: "pre-line" }}>
                                <div style={{ fontWeight: 600 }}>{notice.title}</div>
                                <div style={{ fontSize: 14, color: "#666", marginTop: 4 }}>{notice.content}</div>
                            </td>
                            <td style={{ padding: "10px 8px", width: 120, borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{new Date(notice.createdAt).toLocaleDateString()}</td>
                            <td style={{ padding: "10px 8px", width: 100, borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>
                                <button
                                    style={{
                                        background: "#ff4d4f",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "6px 16px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleDelete(notice.id)}
                                >
                                    삭제
                                </button>
                            </td>
                        </tr>
                    ))}
                    {notices.length === 0 && (
                        <tr>
                            <td colSpan={3} style={{ textAlign: "center", color: "#888", padding: 24 }}>
                                등록된 공지사항이 없습니다.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}